import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiShoppingBag, FiShoppingCart, FiHeart, FiPackage } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext'; // AuthContext import করুন

function BottomNavigation({ cartItemCount }) {
  const location = useLocation();
  const { isAuthenticated } = useAuth(); // Authentication status পান
  const [showLoginSuccess, setShowLoginSuccess] = useState(false);

  // Check if user just logged in from checkout
  useEffect(() => {
    const justLoggedIn = localStorage.getItem('just_logged_in');
    if (justLoggedIn === 'true') {
      setShowLoginSuccess(true);
      localStorage.removeItem('just_logged_in');
      
      // 3 সেকেন্ড পর notification সরিয়ে ফেলুন
      setTimeout(() => {
        setShowLoginSuccess(false);
      }, 3000);
    }
  }, []);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // Navigation items - authenticated user এর জন্য Order History, না হলে Wishlist
  const navItems = [
    { path: '/', icon: FiHome, label: 'Home' },
    { path: '/product', icon: FiShoppingBag, label: 'Shop' },
    { path: '/cart', icon: FiShoppingCart, label: 'Cart', badge: cartItemCount },
    // Conditional rendering: authenticated হলে Order History, না হলে Wishlist
    isAuthenticated 
      ? { path: '/order-history', icon: FiPackage, label: 'Orders' }
      : { path: '/favorites', icon: FiHeart, label: 'Wishlist' },
  ];

  return (
    <>
      {/* Login Success Notification */}
      {showLoginSuccess && (
        <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[1001] animate-slide-down">
          <div className="bg-green-500 text-white px-6 py-3 rounded-lg shadow-xl flex items-center gap-3">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="font-semibold">Successfully logged in!</span>
          </div>
        </div>
      )}

      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-[1000] hidden max-md:block font-['Inter',sans-serif]">
        <div className="flex justify-around items-center h-16 px-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`
                  flex flex-col items-center justify-center gap-1 
                  px-4 py-2 rounded-xl transition-all duration-300 ease-in-out
                  relative min-w-[60px] active:scale-95
                  ${active 
                    ? 'text-[#febd69]' 
                    : 'text-gray-500 hover:text-gray-700'
                  }
                `}
              >
                {/* Active Indicator */}
                {active && (
                  <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-8 h-1 bg-[#febd69] rounded-full" />
                )}
                
                {/* Icon with Badge */}
                <div className="relative">
                  <Icon 
                    className={`
                      transition-all duration-300
                      ${active ? 'text-2xl' : 'text-[22px]'}
                    `}
                    strokeWidth={active ? 2.5 : 2}
                  />
                  
                  {/* Cart Badge */}
                  {item.badge > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 shadow-md animate-pulse">
                      {item.badge > 99 ? '99+' : item.badge}
                    </span>
                  )}
                </div>
                
                {/* Label */}
                <span 
                  className={`
                    text-[11px] tracking-wide transition-all duration-300
                    ${active ? 'font-semibold' : 'font-medium'}
                  `}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
        
        {/* Safe Area for iPhone */}
        <div className="h-safe-area-inset-bottom bg-white" />
      </nav>

      {/* Add animation styles */}
      <style>{`
        @keyframes slide-down {
          from {
            opacity: 0;
            transform: translate(-50%, -20px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
        .animate-slide-down {
          animation: slide-down 0.3s ease-out;
        }
      `}</style>
    </>
  );
}

export default BottomNavigation;